import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class FormGroup extends PureComponent {
    render() {
        const {
            children,
            label,
            required,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['form-group']: true,
        });

        return (
            <div className={classNames} {...props}>
                <label className="">
                    {label}
                    { ! required && (
                        <small className="text-muted"> (optional)</small>
                    )}
                </label>
                {children}
            </div>
        );
    }
}

FormGroup.defaultProps = {

};

export default FormGroup;
